import { useState } from "react";
import { toast } from "sonner";
import { logError } from "../utils/logger";

export const useDevelopmentManagement = (dashboardApi, developerDashboardApi) => {
  const [developments, setDevelopments] = useState([]);
  const [deletedDevelopments, setDeletedDevelopments] = useState([]);

  const fetchDevelopments = async () => {
    try {
      const r = await dashboardApi.getDevelopments();
      if (r.ok) setDevelopments(await r.json());
    } catch (e) {
      logError("useDevelopmentManagement.fetchDevelopments", e);
    }
  };

  const fetchDeletedDevelopments = async () => {
    try {
      const r = await dashboardApi.getDeletedDevelopments();
      if (r.ok) setDeletedDevelopments(await r.json());
    } catch (e) {
      logError("useDevelopmentManagement.fetchDeletedDevelopments", e);
    }
  };

  const handleDeleteDevelopment = async (id) => {
    if (!window.confirm("Eliminar este desarrollo?")) return;
    try {
      const r = await developerDashboardApi.deleteDevelopment(id);
      if (!r.ok) throw new Error();
      toast.success("Desarrollo eliminado");
      fetchDevelopments();
      fetchDeletedDevelopments();
    } catch (e) {
      toast.error("Error");
    }
  };

  const handleRestoreDevelopment = async (id) => {
    try {
      const r = await developerDashboardApi.restoreDevelopment(id);
      if (!r.ok) throw new Error();
      toast.success("Desarrollo restaurado");
      fetchDevelopments();
      fetchDeletedDevelopments();
    } catch (e) {
      toast.error("Error al restaurar");
    }
  };

  return {
    developments,
    deletedDevelopments,
    fetchDevelopments,
    fetchDeletedDevelopments,
    handleDeleteDevelopment,
    handleRestoreDevelopment,
  };
};
